module.exports = __webpack_public_path__ + "static/assets/media/nubi_events_web.cb200b33.mp4";